import React, { useState } from 'react';
import FormsDashboard from "./FormsDashboard"
 
const DynamicForms = () => {
  return (
    <div>
 
      <FormsDashboard />
    </div>
  )
}

export default DynamicForms
